import { getLocale as o } from "../helper.js";
const r = () => ({
  apply: "تطبيق",
  cancel: "إلغاء",
  save: "حفظ",
  delete: "حذف",
  today: "اليوم",
  browse_files: "بحث عن ملف",
  drop_to_upload: "أدرج الملفات هنا",
  select: "اختيار",
  search: "بحث",
  hours: "ساعات",
  mins: "دقائق",
  am_pm: "AM⁄PM",
  no_results_found: "لا توجد نتائج متطابقة",
  of: "من",
  selected_records: "عرض",
  results_found: "عدد نتائج البحث:",
  manage_columns: "عرض الأعمدة",
  row_density: "كثافة الصف",
  full_screen: "عرض شاشة كاملة",
  export: "تصدير",
  filter: "تصفية",
  filtered_by: "تصفية:",
  clear: "إزالة",
  less: "أقل",
  error_date_format: "استخدم صيغة اليوم/الشهر/السنة",
  select_date: "اختر التاريخ"
}), a = () => ({
  apply: "Apply",
  cancel: "Cancel",
  save: "Save",
  delete: "Delete",
  today: "Today",
  browse_files: "Browse files",
  drop_to_upload: "Drop to upload",
  select: "Select",
  search: "Search",
  hours: "Hours",
  mins: "Mins",
  am_pm: "AM⁄PM",
  no_results_found: "No Results found",
  of: "of",
  selected_records: "Selected:",
  results_found: "Results found:",
  manage_columns: "Manage columns",
  row_density: "Row density",
  full_screen: "Full screen",
  export: "Export",
  filter: "Filter",
  filtered_by: "Filtered by:",
  clear: "Clear",
  less: "less",
  error_date_format: "Use the format DD/MM/YYYY",
  select_date: "Select Date"
}), d = (s, ...l) => {
  const t = ["en", "ar"].includes(o()) ? o() : "en", e = {
    ar: r(),
    en: a()
  }[t][s];
  return typeof e == "function" ? e(...l) : e;
};
export {
  d as i18n
};
//# sourceMappingURL=locale.js.map
